import BaseValidator from '~/composer/composer/lib/validation/BaseValidator';

export default class TiktokValidator extends BaseValidator {}
